/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const JsonCreateTenantParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['abbreviatedName', codecString, 'abbreviated_name'],
]);
export class JsonCreateTenant extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return JsonCreateTenantParser.decode(input).map(res => new JsonCreateTenant(res));
    }
    static unsafeDecode(input) {
        return JsonCreateTenant.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JsonCreateTenantParser.encode(data);
    }
    static schema() {
        return JsonCreateTenantParser.schema();
    }
}
